import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/* Actions */

import LoginActions from '../../../actions/loginActions';

/* Components */

import Button from 'components/Button';
import Panel from 'components/Panel';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
import ModalHeadline from 'components/ModalHeadline';
import AuthPageWrapper from './shared/AuthPageWrapper';

/* Utils */
import queryparse from 'tricks/string/queryparse';
import { validateEmailAddress } from 'utils/emails';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ForgotPassword() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var navigate = useNavigate();
  var _queryparse = queryparse(location.search),
    emailFromQuery = _queryparse.email;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    alert = _useState2[0],
    setAlert = _useState2[1];
  var _useState3 = useState(emailFromQuery || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    email = _useState4[0],
    setEmail = _useState4[1];
  function goBackToLogin() {
    navigate('/login');
  }
  function changeHandler(e) {
    var value = e.target.value.trim();
    setEmail(value);
  }
  function resetPassword(e) {
    e.preventDefault();
    var input = email.trim();
    var validatedEmail = validateEmailAddress.test(input) ? input : null;
    if (validatedEmail) {
      LoginActions.resetPassword({
        email: validatedEmail
      }).then(function () {
        navigate('/password-requested');
      }).catch(function (err) {
        if (err !== null && err !== void 0 && err.code) {
          setAlert(t(err.code));
        } else {
          setAlert(err === null || err === void 0 ? void 0 : err.message);
        }
      });
    } else {
      setAlert(t('error_invalid_email'));
    }
  }
  return /*#__PURE__*/_jsx(AuthPageWrapper, {
    children: /*#__PURE__*/_jsxs("form", {
      onSubmit: resetPassword,
      children: [/*#__PURE__*/_jsx(ModalHeadline, {
        title: t('forgot_pw_title'),
        onClose: goBackToLogin
      }), /*#__PURE__*/_jsx(Panel, {
        children: /*#__PURE__*/_jsx("p", {
          children: t('forgot_pw_description')
        })
      }), /*#__PURE__*/_jsx(Panel, {
        children: /*#__PURE__*/_jsx(FormField, {
          label: t('email'),
          alert: alert,
          children: /*#__PURE__*/_jsx(TextInput, {
            type: "email",
            placeholder: t('email_placeholder'),
            autoComplete: "username",
            spellCheck: "false",
            autoCorrect: "off",
            value: email,
            onChange: changeHandler
          })
        })
      }), /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: /*#__PURE__*/_jsx(Button, {
          id: "send_password_reset_button",
          type: "submit",
          variant: "primary",
          children: t('forgot_pw_submit')
        })
      })]
    })
  });
}
export default ForgotPassword;